module.exports = __webpack_public_path__ + "h5/img/loading.2768891e.png";